import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export interface GeneralState {
    playerName?: string,
    serverName: string,
    playerUid?: string,
    loggedIn: boolean
    menuOpened: boolean,
    role: 'player' | 'admin',
}

const initialState: GeneralState = {
    playerName: undefined,
    serverName: 'dd',
    playerUid: undefined,
    loggedIn: false,
    menuOpened: false,
    role: 'player',
}

export const generalSlice = createSlice({
    name: 'general',
    initialState,
    reducers: {
        openMenu: (state) => {
            return {
                ...state,
                menuOpened: true,
            }
        },
        closeMenu: (state) => {
            return {
                ...state,
                menuOpened: false,
            }
        },
        setPlayerName: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                playerName: action.payload,
            }
        },
        setServerName: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                serverName: action.payload,
            }
        },
        setPlayerUid: (state, action: PayloadAction<string>) => {
            return {
                ...state,
                uid: action.payload,
            }
        },
        login: (state) => {
            return {
                ...state,
                loggedIn: true,
            }
        },
        logout: (state) => {
            return {
                ...state,
                loggedIn: false,
                role: 'player',
            }
        },
        setAdminRole: (state) => {
            return {
                ...state,
                role: "admin",
            }
        }
    }
});

export const { openMenu, closeMenu, setPlayerName, setServerName, setPlayerUid, login, logout, setAdminRole } = generalSlice.actions;
export default generalSlice.reducer;